
import React from 'react'
import { KickerMatchdayTeaserEntry } from '../helper/interfaces';
import TickerEncounter from "./TickerEncounter";
import { TeaserData } from './teaser'
import TickerTable from './TickerTable';


export default function TeaserKickerMatchday(data: TeaserData) {
  const teaser = data.teaser as KickerMatchdayTeaserEntry;
  
  return (
    <React.Fragment>

      {teaser.sportsMatches && (
        <div>
          { teaser.title && 
            <div className="teaser-list__header">
              <div className="teaser-list__header__title">
                {teaser.title}
              </div>
            </div>
          }
          {teaser.sportsMatches && (
            <div className="ticker">
              <TickerEncounter sportsMatches={teaser.sportsMatches} />
            </div>
          )}
        </div>
        
      )}

      {teaser.sportsTables && teaser.sportsTables.length > 0 && (
        teaser.sportsTables.map((sportsTable, index) => (
          <div className="ticker" key={`ticker-${index}`}>
            <TickerTable sportsTable={sportsTable} />
          </div>
        ))
      )}
      
    </React.Fragment>
  )
}
